export default "__VITE_ASSET__CtP4JYTz__"